import Swiper from "swiper";
import SwiperCore, {Navigation, Autoplay, Pagination} from "swiper/core";
import {getElement} from "./helpers.js";

SwiperCore.use([Navigation, Autoplay, Pagination]);

function productItemSectionSlider(el, clazz, variable) {
    if (matchMedia("(max-width: 767px)").matches) {

        variable = new Swiper(document.querySelector(`[data-swiper="${el}"]`), {
            slidesPerView: 1.85,
            spaceBetween: 10,
            // loop: true,
            // slideClass: "product-item-grid__col",
            slideClass: clazz,
            grabCursor: true,
            navigation: {
                nextEl: `.slider__next-${el}`,
                prevEl: `.slider__prev-${el}`,
            },
        });
    } else {
        if (variable) {
            variable.destroy();
        }
        return;
    }
}

function alternativeModalSwiper(el) {
    const swiperAlternativeModal = new Swiper(
        document.querySelector(`[data-swiper="${el}"]`),
        {
            slidesPerView: 1,
            // slideClass: "compare-item",
            // loop: true,
            // init: true,
            navigation: {
                nextEl: `.slider__next-${el}`,
                prevEl: `.slider__prev-${el}`,
            },
            breakpoints: {
                1920: {
                    slidesPerView: 3,
                },
                1440: {
                    slidesPerView: 3,
                },
                1024:{
                    slidesPerView: 2,
                },
                //
                // 1023: {
                //     slidesPerView: 2,
                // },
                768: {
                    slidesPerView: 2,
                },
            },
        }
    );
}

//
function rewardPageSlider() {
    if (getElement('[data-swiper="reward-page"]')) {
        const swiperRewardPage = new Swiper(
            getElement('[data-swiper="reward-page"]'),
            {
                slidesPerView: 1.35,
                spaceBetween: 20,
                slideClass: "reward__item",

                autoplay: {
                    delay: 5000,
                },
                breakpoints: {
                    1300: {
                        slidesPerView: 5,
                    },

                    1024: {
                        slidesPerView: 4,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                },
            }
        );
    }

}

function blogRelatedSlider() {
    if (getElement('[data-swiper="blog-related"]')) {
        const swiperBlogRelated = new Swiper(
            getElement('[data-swiper="blog-related"]'),
            {
                slidesPerView: 1.25,
                spaceBetween: 20,
                slideClass: "blog__item",
                loop: true,
                navigation: {
                    nextEl: `.slider__next-blog-related`,
                    prevEl: `.slider__prev-blog-related`,
                },
                breakpoints: {
                    1920: {
                        slidesPerView: 4,
                    },

                    1024: {
                        slidesPerView: 3,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                },
            }
        );
    }

}

export {productItemSectionSlider, alternativeModalSwiper, blogRelatedSlider, rewardPageSlider};
